// ============================================================================
// App Configuration — populated from environment variables at build time
// ============================================================================

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:4000',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
};
